import BottomsheetProps from '@ui/components/sheet/BottomsheetProps';
import BottomsheetWamp from '@ui/components/sheet/Bottomsheet';
import {CreateTeamProvider} from '@ui/provider/CreateTeamProvider';
import React from 'react';
import {TeamCreate} from '@ui/features/team/create/TeamCreateScreen';
import {useTranslation} from 'react-i18next';

interface Props extends Omit<BottomsheetProps, 'children'> {
    onTeamCreated: (teamId: string) => void;
}

export const TeamCreateModal = (props: Props) => {
    const {onTeamCreated, isOpen, onClose} = props;
    const {t} = useTranslation();

    const onCloseHandler = () => {
        onClose();
    };

    const onTeamCreatedHandler = (teamId: string) => {
        onClose();
        onTeamCreated(teamId);
    };

    return (
        <BottomsheetWamp isOpen={isOpen} onClose={onCloseHandler} _bottomSheetProps={{snapPoints: ['75%']}} title={t('team.create.title')}>
            <CreateTeamProvider>
                <TeamCreate key={1} onTeamCreated={onTeamCreatedHandler} />
            </CreateTeamProvider>
        </BottomsheetWamp>
    );
};
